import { UsersApi } from "@tytapp/api";

declare let __SPOTIM__;
let INSTALLED = false;

export function showSpotProfile(user: SpotUser) {
    if (!INSTALLED)
        throw new Error(`You must install the integration first!`);

    if (typeof __SPOTIM__ === 'undefined')
        return;

    __SPOTIM__.initApp('tytspot:user-profile', {
        mode: 'main',
        onClose: () => { },
        postId: 'postId',
        user
    });
}

export interface SpotUser {
    displayName: string;
    email: string;
    id: string;
    imageId: string;
    isAdmin: boolean;
    isCommunityModerator: boolean;
    isEmailVerified: boolean;
    isFallbackUser: boolean;
    isJournalist: boolean;
    isModerator: boolean;
    isMuted: boolean;
    isOnline: boolean;
    isRegistered: boolean;
    isSuperAdmin: boolean;
    messagesVoted: number;
    notificationsCount: number;
    reputation: { total: number, receivedRankedUp: number, follow: number; };
    ssoData: { isSubscriber: boolean; };
    unseenNotificationsCount;
    username: string;
}

export function install(callback: (user: SpotUser) => void) {
    if (typeof window === 'undefined') // Client side only
        return;

    if (typeof __SPOTIM__ === 'undefined') {
        console.warn(`Could not install Spot.im/TYT integration: Spot.im launcher is not yet loaded`);
        return;
    }

    if (INSTALLED) // Install it only once
        return;

    function override(method, impl: (original: (...args) => any) => Function) {
        let value = __SPOTIM__[method];
        let func = impl(function () {
            if (value)
                return value.apply(__SPOTIM__, arguments);
        });

        Object.defineProperty(
            __SPOTIM__,
            method,
            {
                get: () => value ? func : undefined,
                set: v => value = v
            }
        );
    }

    override('initApp', original => {
        return function (app, params) {
            console.log(`SPOTIM initApp with:`);
            console.dir(arguments);

            if (app === 'user-profile') {
                callback(params.user);
                return;
            }

            if (app === 'tytspot:user-profile')
                app = 'user-profile';

            return original(app, params);
        };
    });

    console.log(`Successfully installed Spot.im/TYT integration`);
    INSTALLED = true;
}